/* @flow */
import { TrackingTags } from "shared/src/tracking/Tracking";
import { ZeroResultTypes } from "shared/src/types/ZeroResultType";
import { trackStructuredEvent } from "shared/src/utils/TrackingUtil";

export function trackMetroMarketsResult(query: string, nrItems: number) {
    const tags: TrackingTags = { query, nrItems, zeroResultType: ZeroResultTypes.Marketplace };
    trackStructuredEvent("zeroResults.resultMetroMarketsSuggestion", { tags: tags });
}

export function trackCardViewMetroMarketsResult(query: string, title: string, offerId: string) {
    const tags: TrackingTags = { query, title, offerId, zeroResultType: ZeroResultTypes.Marketplace };
    trackStructuredEvent("zeroResults.cardViewMetroMarketsSuggestion", { tags: tags });
}

export function trackOpenMetroMarketsResult(query: string, title: string, offerId: string) {
    const tags: TrackingTags = { query, title, offerId, zeroResultType: ZeroResultTypes.Marketplace };
    trackStructuredEvent("zeroResults.openMetroMarketsSuggestion", { tags: tags });
}

export function trackRecentlyViewedResult(nrItems: number) {
    const tags: TrackingTags = { nrItems, zeroResultType: ZeroResultTypes.RecentlyViewed };
    trackStructuredEvent("zeroResults.resultRecentlyViewedSuggestion", { tags: tags });
}
